const en = {
  i18nView: {
    login: 'Login',
    account: 'Account',
    home: 'Home',
    appIntro: 'Introduction',
    backgroundIntro: 'Background:',
    back1: 'The purpose of this contract (DApp) is to store and share the basic information based on an EOS account. So as to facilitate blockchain browsers, wallets, DApp and users to know more information about the account.',
    back2: 'In order to enable more users to pay attention to the meaning of this information. we add a `FOMO` design to encourage people to edit their information ASAP.',
    rule: 'Rule:',
    rule1: '1.In the initial state, anyone can edit information for an account, the initial price is 0.1 EOS. ',
    rule2: '2.The price of each secondary modification is 1.5 times of the previous one, of which 1.4 times is returned to the previous modifier, and the rest is left in the contract for a subsequent contract upgrade.',
    rule3: '3.If an account has been modified by another account, when the account owner updates the account, he needs to pay half of the previous modification price to the previous modifier.',
    rule4: '4.When an account is edited by the account owner, no one else can modify the information of the account. Only the account owner can modify the information and the subsequent modification is free of charge.',
    personalInfo: 'Profile',
    nickname: 'Nickname',
    lastModifier: 'Last Modifier',
    searchList: 'Search List',
    intrestList: 'Related Accounts',
    lastPrice: 'Last Price',
    empty: '-',
    noSuchAccount: 'No such account',
    edit: 'Edit',
    locked: 'Edited by the owner, locked',
    avatar: 'Avatar Image',
    enterIntro: 'Description',
    website: 'Website',
    wechatId: 'Wechat ID',
    confirmEdit: 'to Confirm',
    shortLocked: 'Locked',
    cost: 'Pay',
    intro: 'Intro',
    success: 'Success!',
    mine: 'Involved',
    interested: 'Interested',
    searchAccount: 'Search EOS Account',
    recently: 'Recent',
    supportList: 'Support List',
    inviteIntro: 'Invite friends for Rewards!',
    inviteTips: 'The referral link will take effect after you edited your own account',
    inviteTips1: 'When invitee edits any accounts which in an initial state, half of he/she cost is given to the inviter, i.e. 0.05 EOS.',
    inviteTips2: 'When invitee edits a non-personal and non-initial account, the inviter is given 5% EOS of the previous modified price.',
    copy: 'Copy',
    viewInBrowser: 'View in a block explorer'
  }
};

export default en;